<template>
  <div>
    <!-- pc -->
    <div class="special_8">
      <div class="row1">
        <div class="title">
          <div class="content">
            <a
              :href="cCityScence.cityLink"
              v-html="cCityScence.cityWebName"
              target="_blank"
            ></a>
            <span>官网</span>
          </div>
        </div>
        <div class="img fl">
          <a :href="cCityScence.cityLink" target="_blank">
            <img :src="cCityScence.cityPic" alt="" style="border-style: none" />
          </a>
        </div>
        <div class="text fl">
          <a
            :href="cCityScence.cityLink"
            v-html="cCityScence.cityDescription"
            target="_blank"
          >
          </a>
        </div>
      </div>
      <!-- <div class="row2">
      <ul class="card1">
        <li v-for="(item, index) in 5" :key="index">
          <i> </i>
          <a
            :href="cInfos.info1.link"
            v-html="cInfos.info1.title"
            target="_blank"
          ></a>
          <span class="date fr" v-html="cInfos.info1.date"></span>
        </li>
      </ul>
    </div> -->
    </div>
    <!-- 移动端 -->
    <div class="mobile">
      <div class="row1">
        <div class="title">
          <div class="content">
            <a
              :href="cCityScence.cityLink"
              v-html="cCityScence.cityWebName"
              target="_blank"
            ></a>
            <span>官网</span>
          </div>
        </div>
        <div class="img">
          <a :href="cCityScence.cityLink" target="_blank">
            <img :src="cCityScence.cityPic" alt="" style="border-style: none" />
          </a>
        </div>
        <div class="text">
          <a
            :href="cCityScence.cityLink"
            v-html="cCityScence.cityDescription"
            target="_blank"
          >
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "v-special-city",
  components: {},
  props: {
    cCityScence: {
      type: Object,
      default: function () {
        return {};
      },
    },
    cTag: {
      type: Object,
      default: function () {
        return {
          title: "呼和浩特市人民政府",
          Link: "###",
          tag: "官网",
          img: require("../../assets/img/hhht.png"),
          intro:
            " 呼和浩特是内蒙古自治区首府，全区政治、经济、文化、科教和金融中心，誉为“中国乳都”，荣膺国家森林城市、中国优秀旅游城市、国家历史文化名城、全国十大幸福城市、全国民族团结进步模范城市、全国双拥模范城市等称号。",
        };
      },
    },
    cInfos: {
      type: Object,
      default: function () {
        return {
          info1: {
            link: "###",
            title: "内蒙古自治区财政厅",
            date: "2020-08-01",
          },
        };
      },
    },
  },
  data() {
    return {};
  },
  watch: {},
  computed: {},
  methods: {},
  created() {},
  mounted() {},
};
</script>

<style lang="less" scoped>
.fl {
  float: left;
}
.fr {
  float: right;
}
@media screen and (min-width: 751px) {
  .mobile {
    display: none;
  }
  .special_8 {
    display: block;
    width: 823px;
    margin-bottom: 40px;
    // height: 308px;
    .row1 {
      width: 823px;
      height: 128px;
      margin-bottom: 40px;
      border: 1px solid rgb(204, 204, 204);
      .title {
        width: 823px;
        height: 46px;
        font-size: 16px;
        line-height: 24px;
        border-bottom: 1px solid rgb(204, 204, 204);
        background-color: rgb(238, 238, 238);
        .content {
          height: 21px;
          padding-left: 10px;
          border-left: 4px solid rgb(211, 11, 21);
          font-size: 16px;
          font-weight: bold;
          top: 50%;
          position: relative;
          transform: translateY(-50%);
          margin-left: 15px;
          a {
            color: #333;
          }
          span {
            margin-left: 10px;
            color: #fff;
            background-color: rgb(0, 66, 162);
            padding: 3px 4px 3px 4px;
            font-size: 14px;
            font-weight: normal;
          }
        }
      }
      .img {
        width: 351px;
        height: 80px;
        img {
          width: 100%;
          height: 100%;
        }
      }
      .text {
        width: 439px;
        height: 65px;
        font-size: 14px;
        line-height: 30px;
        padding-top: 15px;
        padding-left: 10px;
        padding-right: 10px;
        overflow: hidden;
        display: -webkit-box;
        text-overflow: ellipsis;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
        a {
          color: #333;
        }
      }
    }
    .row2 {
      width: 823px;
      margin-top: 10px;
      ul {
        width: 823px;
        margin: 0;
        padding: 0;
        li {
          width: 823px;
          height: 28px;
          font-size: 14px;
          line-height: 24px;
          i {
            display: inline-block;
            width: 15px;
            height: 15px;
            background-image: url(../../assets/img/pointer.png);
            background-size: 100% 100%;
            background-repeat: no-repeat;
            top: 10%;
            position: relative;
          }
          a {
            // text-decoration: underline;
            color: black;
          }
          a:hover {
            color: rgb(1, 82, 147);
          }
          span {
            width: 80px;
            margin-left: 10px;
            text-align: right;
          }
        }
      }
    }
  }
}
@media screen and (max-width: 750px) {
  @w: 7.5vw;
  .special_8 {
    display: none;
  }
  .mobile {
    display: block;
    width: 740 / @w;
    padding-bottom: 10 / @w;
    border-bottom: 15 / @w solid rgb(230, 230, 230);
    margin-bottom: 20 / @w;
    // height: 308px;
    .row1 {
      width: 740 / @w;
      height: 290 / @w;
      margin-bottom: 20 / @w;
      border: 1px solid rgb(204, 204, 204);
      .title {
        width: 740 / @w;
        height: 50 / @w;
        // font-size: 16 / @w;
        line-height: 30 / @w;
        border-bottom: 1 / @w solid rgb(204, 204, 204);
        background-color: rgb(238, 238, 238);
        .content {
          height: 21 / @w;
          padding-left: 10 / @w;
          border-left: 4 / @w solid rgb(211, 11, 21);
          // font-size: 16 / @w;
          font-weight: bold;
          top: 50%;
          position: relative;
          transform: translateY(-50%);
          margin-left: 15 / @w;
          a {
            color: #333;
          }
          span {
            margin-left: 10 / @w;
            color: #fff;
            background-color: rgb(0, 66, 162);
            padding: 3 / @w 4 / @w 2 / @w 4 / @w;
            // font-size: 14 / @w;
            font-weight: normal;
          }
        }
      }
      .img {
        width: 100%;
        height: 130 / @w;
        img {
          width: 100%;
          height: 100%;
        }
      }
      .text {
        width: 710 / @w;
        height: 80 / @w;
        // font-size: 20 / @w;
        line-height: 45 / @w;
        padding-top: 15 / @w;
        padding-left: 20 / @w;
        // padding-right: 20 / @w;
        overflow: hidden;
        display: -webkit-box;
        text-overflow: ellipsis;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
        a {
          color: #333;
        }
      }
    }
  }
}
</style>